module.exports = __webpack_public_path__ + "img/15pts45.6f50b6ce.png";